// removed by extract-text-webpack-plugin
module.exports = {"textDanger":"_2QPuzN2m7hEJ3QY9fEuzBm","spaceLeft":"_3EdK9Z6Ujjd3N7RdbD3HT9","spaceBoth":"_2RqPubC6zxM7Y6roG01oC9","spaceRight":"_3OtFtL13DHB-97-OwaFrRk","clickable":"_29kHsDbTclOgLcId0_7z2Q","active":"_2OYa1rKbQqqaHRixnd0ZzF","scrolling":"_1p6I7CcZo-9S531QV71s5V","collapseRow":"_1VC-XpHqhNdt-0gUAmhpk1","collapseCell":"_1BLBCq0NIIPueVZg206zSp","emptyFallback":"_2JZCgcWB7cKV9CZJp2MAWE","isInitializing":"FjBJJMkoK9XQEuen21Nip","dateHeading":"_2Su_hwsEV6ywfkqWVnsw87","dateCell":"_LgQFwte0pzEslF_W3GLO","dateHeadingTwoRows":"_2epNdyhkDUFf2HpvSQ1_0","twoRows":"_1KDimJKIFaJp835aClrczY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisTable.scss
// module id = 1075
// module chunks = 0